import moment from "moment-timezone";
/**
 * 無期限開催終了日時
 */

export var MaxDateTime = moment('9999-12-31 23:59:00', 'YYYY-MM-DD HH:mm:ss');
/**
 * 期間指定か否か確認
 *
 * @param time
 */

export function IsSpecifyPeriodMoment(time) {
  return time == null ? true : !time.isSame(MaxDateTime);
}
/**
 * 期間指定か否か確認
 *
 * @param time
 */

export function IsSpecifyPeriodDate(time) {
  return time == null ? true : !moment(time).isSame(MaxDateTime);
}
/**
 * momentに変換
 *
 * @param time 時間
 */

export function ToMoment(time) {
  return moment(time);
}
/**
 * momentに変換
 *
 * @param time 時間
 */

export function ToMoment2(time) {
  return time == null ? null : moment(time);
}
/**
 * momentに変換
 *
 * @param ticks Ticks
 */

export function ToDateString(ticks) {
  var d = moment(ticks / 10000);
  return d.format();
}
/**
 * momentに構文解析
 *
 * @param date 年月日
 * @param hours 時
 * @param minutes 分
 */

export function parseMoment(date, hours, minutes) {
  var d = moment({
    year: date.year(),
    month: date.month(),
    date: date.date(),
    hour: hours,
    minute: minutes,
    second: 0,
    millisecond: 0
  }).toDate();
  return d;
}
/**
 * Dateに変換
 * @param time 時間
 */

export function toDate(time) {
  return time == null ? undefined : time.toDate();
}
/**
 * stringに変換
 * @param time 時間
 */

export function toString(time) {
  return time == null ? null : time.format("YYYY-MM-DDTHH:mm:ss");
}
/**
 * nullの場合ブランクを戻します。
 *
 * @param s 文字列
 * @returns nullの場合ブランクを戻します。
 */

export function NullStringToBlank(s) {
  return s == null ? "" : s;
}
/**
 * nullの場合ブランクを戻します。
 *
 * @param n 数値
 * @returns nullの場合ブランクを戻します。
 */

export function NullNumberToBlank(n) {
  return n == null ? "" : n.toString();
}
/**
 * ゼロパディング
 *
 * @param num 数値
 * @param length 長さ
 */

export function ZeroPadding(num, length) {
  return ('0000000000' + num).slice(-length);
}
/**
 * 拡張子を取得します。
 *
 * @param filename ファイル名
 */

export function getFileExtension(filename) {
  var result = /[^.]+$/.exec(filename);
  return result == null || result.length == 0 ? null : result[0].toLowerCase();
}